import options from './radio-wide.component';

export default {
    selector: 'dtRadioStatusWide',
    options
};
